import { render, staticRenderFns } from "./DirtyButton.vue?vue&type=template&id=28ed01d0&scoped=true"
import script from "./DirtyButton.vue?vue&type=script&lang=js"
export * from "./DirtyButton.vue?vue&type=script&lang=js"
import style0 from "./DirtyButton.vue?vue&type=style&index=0&id=28ed01d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed01d0",
  null
  
)

export default component.exports